//lib

//redux
import { useSelector } from "react-redux";

//component
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Image from "../../../components/element/image";
import { Logo, Sample } from "../../../assets/images";
import Button from "../../../components/element/button";
import ArrowButton from "../../../components/common/common.arrow.button";
import Container from "../../../components/element/container";
import Icon from "../../../components/element/icon";
import { Galleria } from "primereact/galleria";
import { useEffect, useRef, useState } from "react";

export default function ProductCarousel({ product }) {
  const { filterList } = useSelector((state) => state.product);

  const images =
    product?.media?.length > 0
      ? product.media.filter(
          (item, index) => item.collection_type === "attachment"
        )
      : [];

  const itemTemplate = (item) => {
    return (
      <img
        src={item.url}
        alt=""
        style={{
          width: "100%",
          display: "block",
          cursor: "grab",
          userSelect: "none",
        }}
        draggable={false}
      />
    );
  };

  const thumbnailTemplate = (item) => {
    return <img src={item.url} alt="" style={{ display: "block" }} />;
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const galleriaRef = useRef(null);

  useEffect(() => {
    const galleryElement = galleriaRef.current?.getElement();
    if (!galleryElement) return;

    let startX = 0;
    let isDragging = false;

    // Handle Touch Events
    const handleTouchStart = (e) => {
      startX = e.touches[0].clientX;
    };

    const handleTouchEnd = (e) => {
      const endX = e.changedTouches[0].clientX;
      handleSwipe(startX, endX);
    };

    // Handle Mouse Events
    const handleMouseDown = (e) => {
      isDragging = true;
      startX = e.clientX;
    };

    const handleMouseMove = (e) => {
      if (!isDragging) return;
    };

    const handleMouseUp = (e) => {
      if (!isDragging) return;
      isDragging = false;
      const endX = e.clientX;
      handleSwipe(startX, endX);
    };

    // Swipe Logic
    const handleSwipe = (start, end) => {
      const diffX = start - end;
      if (diffX > 50) {
        // Drag Left → Next Image
        setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
      } else if (diffX < -50) {
        // Drag Right → Previous Image
        setActiveIndex(
          (prevIndex) => (prevIndex - 1 + images.length) % images.length
        );
      }
    };

    // Add Event Listeners
    galleryElement.addEventListener("touchstart", handleTouchStart);
    galleryElement.addEventListener("touchend", handleTouchEnd);
    galleryElement.addEventListener("mousedown", handleMouseDown);
    galleryElement.addEventListener("mousemove", handleMouseMove);
    galleryElement.addEventListener("mouseup", handleMouseUp);
    galleryElement.addEventListener("mouseleave", handleMouseUp); // Handle cases where mouse leaves

    return () => {
      galleryElement.removeEventListener("touchstart", handleTouchStart);
      galleryElement.removeEventListener("touchend", handleTouchEnd);
      galleryElement.removeEventListener("mousedown", handleMouseDown);
      galleryElement.removeEventListener("mousemove", handleMouseMove);
      galleryElement.removeEventListener("mouseup", handleMouseUp);
      galleryElement.removeEventListener("mouseleave", handleMouseUp);
    };
  }, [images.length]);

  return (
    <Container tag="article" className="fit-height">
      <Galleria
        ref={galleriaRef}
        value={images}
        // responsiveOptions={responsiveOptions}
        activeIndex={activeIndex}
        onItemChange={(e) => setActiveIndex(e.index)}
        numVisible={5}
        style={{ maxWidth: "640px" }}
        showItemNavigators
        circular
        // showItemNavigatorsOnHover
        item={itemTemplate}
        thumbnail={thumbnailTemplate}
      />
    </Container>
  );
}
